export const GET_COST_CENTER = 'GET_COST_CENTER';
export const LOAGIND_COST_CENTER = 'LOAGIND_COST_CENTER';
export const SAVE_LOADER_COST_CENTER = 'SAVE_LOADER_EQUIPMENT';

export const FORM_FAIL = "FORM_FAIL";
export const COST_CENTER_FAIL = "COST_CENTER_FAIL";

